module.exports = __webpack_public_path__ + "assets/img/6_519_big.7aca7f39.jpg";